module.exports = __webpack_public_path__ + "static/media/banner4.1e564bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/all/banner4.png
// module id = 1845
// module chunks = 1